import { ApiCore } from './utilities/core'


export const topDriversChartsAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        getSingle: true,
        url: `api/${tenantSlug}/charts`
    })
};
